// src/theme.js
import colors from 'vuetify/es5/util/colors'

export default {
  primary: {
    base: colors.amber.darken4,
    darken1: colors.purple.darken2,
    darken3: colors.purple.darken3,
  },
  secondary: colors.indigo,
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  tertiary: colors.pink.base,
}


// WEBPACK FOOTER //
// ./src/themes/bi_light.js